import { render, staticRenderFns } from "./CommentForm.vue?vue&type=template&id=07a55295&scoped=true&"
import script from "./CommentForm.js?vue&type=script&lang=js&"
export * from "./CommentForm.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a55295",
  null
  
)

export default component.exports